import { createAction, props } from "@ngrx/store";

export const authUserLogin = createAction('[Auth] Login',
  props<any>()
);
export const authAccountToggle = createAction('[Auth] Account Toggle', props<any>())
export const authUserLogout = createAction('[Auth] Logout');
export const authUserLoginSuccess = createAction('[Auth] Login Success');